import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const ListSelectionStyled = styled(Box).attrs({
  p: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
`;
